import {api} from 'services/api';
import {ResponseData} from 'types/response-data';
import queryParams from 'utils/query-params';

const getInvoicesCommercialProductsExport = api.injectEndpoints({
  endpoints: builder => ({
    getInvoicesCommercialProductsExport: builder.query<Response, Request>({
      query: params => {
        return {
          method: 'GET',
          url: `/export/invoices-commercial-products`,
          params: queryParams(params, '|'),
        };
      },
    }),
  }),
});

type Request = {};

type Response = ResponseData<{message: string}>;

export const {useLazyGetInvoicesCommercialProductsExportQuery} =
  getInvoicesCommercialProductsExport;
